
export const AdminSharedApnsComponent = () => {

    return (
        <div className='admin-content'>
            <h1 color='white'>Admin Shared Apns</h1>
        </div>
    );
}